<template>
  <div id="navbar-container">
    <b-navbar toggleable="lg" >
      <b-navbar-brand href="#" @click.prevent="redirectUser('')" style="color: rgba(0, 0, 0, 0.5)">CompCorp</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-navbar-nav>
            <b-nav-item href="#" @click.prevent="redirectUser('')">{{$t('charts.base.title_menu')}}</b-nav-item>
            <!--<b-nav-item href="#" @click.prevent="redirectUser('pos/')">{{$t('charts.pos.title_menu')}}</b-nav-item>-->
          </b-navbar-nav>
          <b-nav-item-dropdown :text="this.$t('services')" right>
            <b-dropdown-item href="#" @click.prevent="redirectUser('pos/')">{{$t('menu.pos')}}</b-dropdown-item>
            <b-dropdown-item href="#" @click.prevent="redirectUser('lemma/')">{{$t('menu.lemma')}}</b-dropdown-item>
            <b-dropdown-item href="#" @click.prevent="redirectUser('lemma_dif/')">{{$t('menu.lemma_dif')}}</b-dropdown-item>
            <b-dropdown-item href="#" @click.prevent="redirectUser('ne/')">{{$t('menu.ne')}}</b-dropdown-item>
            <b-dropdown-item href="#" @click.prevent="redirectUser('term/')">{{$t('menu.term')}}</b-dropdown-item>
            <b-dropdown-item href="#" @click.prevent="redirectUser('verbs/')">{{$t('menu.verbs')}}</b-dropdown-item>
            <b-dropdown-item href="#" @click.prevent="redirectUser('sentstat/')">{{$t('menu.sentstat')}}</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-form class="dropdown-button" v-if="this.$i18n.locale === 'pl'" @click.prevent="changeLanguage('en')">
            <b-button class="lang-button" >
              <img src="../assets/ico/icon_pl.png" height="70%" width="100%">
            </b-button>
          </b-nav-form>
          <b-nav-form class="dropdown-button" v-if="this.$i18n.locale === 'en'" @click.prevent="changeLanguage('pl')">
            <b-button class="lang-button">
              <img src="../assets/ico/icon_en.png" height="70%" width="100%">
            </b-button>
          </b-nav-form>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
  import {BNavbar} from 'bootstrap-vue'

  export default {
    name: 'NavBar',
    components: {
      BNavbar
    },
    data () {
      return {
        changeLanguage: function (event) {
          this.$i18n.locale = event.toString()
          this.$forceUpdate()
        }
      }
    },
    methods: {
      redirectUser: function (reqest) {
        let currentTaskId = this.$route.params['taskId']
        this.$router.push('/' + reqest + currentTaskId)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1 {
    margin-left: 30px;
    padding-top: 9px;
  }
  #navbar-container{
    /*padding: 5px;*/
    /*height: 66px;*/
    /*background-color: var(--light_blue);*/
    background-color: var(--golden_light);

  }
  .lang-button, .lang-button:active, .lang-button:focus {
    background-color: transparent !important;
    outline: 0;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    border: none;
  }
  .lang-button:focus:active, .lang-button:hover{
    background-color: transparent !important;
  }
  .dropdown-item:active {
    background-color: var(--golden);
  }
  .dropdown-item:hover {
    background-color: var(--golden);
    color: var(--blue_background);
  }
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue